import { useState, createContext, useEffect, FC } from "react";
import { getFromLocal, GetRoleId } from "../utils";
import { ContextType } from "src/types/ContextsType/Context.type";
import { IContext } from "src/types/ContextsType/APIContext.type";
import { useSystemHealth } from "src/hooks/useSystemHealth";
import { userPharmacyLookup } from "src/types/hospital";

// Create context with initial value
export const ContextValues = {
  isLoggedIn: false,
  setIsLoggedIn: () => { },
  userName: null,
  setUserName: () => { },
  loading: 0,
  setLoading: () => { },
  authorizedPages: null,
  setAuthorizedPages: () => { },
  searchArea: true,
  setToggleSearch: () => { },
  searchData: [],
  setSearchData: () => { },
  customSearchData: {},
  setCustomSearchData: () => { },
  searchTypes: {},
  setSearchTypes: () => { },
  clearField: true,
  ToggleClearFeild: () => { },
  UserRoleId: null,
  dataLoading: 0,
  setDataLoading: () => { },
  reloadTable: false,
  ToggleReloadTable: () => { },
  sideBarCollapsed: false,
  setSideBarCollapsed: () => { },
  systemIsHealthy: false,
  fetchHealth: () => { },
  hasNetworkConnection: false,
  pharmaciesLookup: null,
  setPharmaciesLookup: () => { }
};

export const Context = createContext<ContextType>(ContextValues);

const ContextC: FC<IContext> = ({ children }) => {

  const [isLoggedIn, setIsLoggedIn] = useState(getFromLocal("accessToken") ? true : false);
  const [userName, setUserName] = useState<string | null>(null);
  const [loading, setLoading] = useState(0);
  const [dataLoading, setDataLoading] = useState(0);

  const [authorizedPages, setAuthorizedPages] = useState<any[] | null>(null);

  const [searchArea, setToggleSearch] = useState(true);
  const [searchData, setSearchData] = useState([]);
  const [customSearchData, setCustomSearchData] = useState({});
  const [searchTypes, setSearchTypes] = useState({});
  const [clearField, ToggleClearFeild] = useState(true);

  const [UserRoleId, setUserRoleId] = useState<string | null>(null)
  const [reloadTable, ToggleReloadTable] = useState(true)


  const [sideBarCollapsed, setSideBarCollapsed] = useState(false)
  const { systemIsHealthy, fetchHealth, hasNetworkConnection } = useSystemHealth();
  const [pharmaciesLookup, setPharmaciesLookup] = useState<userPharmacyLookup[] | null>(null);

  useEffect(() => {
    let RoleId = GetRoleId()

    if (!RoleId)
      return setUserRoleId(null)

    setUserRoleId(RoleId.split('"')[1])
  }, [isLoggedIn])



  return <Context.Provider value={{
    isLoggedIn,
    setIsLoggedIn,
    userName,
    setUserName,
    loading,
    setLoading,
    searchData,
    searchTypes,
    ToggleClearFeild,
    clearField,
    setSearchTypes,
    UserRoleId,
    setSearchData,
    dataLoading,
    setDataLoading,
    authorizedPages,
    setToggleSearch,
    searchArea,
    setAuthorizedPages,
    customSearchData,
    setCustomSearchData,
    reloadTable,
    ToggleReloadTable,
    sideBarCollapsed,
    setSideBarCollapsed,
    systemIsHealthy,
    fetchHealth,
    hasNetworkConnection,
    setPharmaciesLookup,
    pharmaciesLookup
  }}>{children}</Context.Provider>;
};

export default ContextC;